import { atom, useAtomValue, useSetAtom } from 'jotai';

export const isSbsMode = atom<boolean>(false);

export const useIsSbsMode = () => {
  return useAtomValue(isSbsMode);
};

export const useSetIsSbsMode = () => {
  return useSetAtom(isSbsMode);
};
